import React from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  IgButton,
  IgCheckbox,
  IgSelect,
  IgTextField,
} from "@intelligems/ig-theme";
import {
  ExperienceStatusList,
  ExperienceTestTypeList,
} from "@intelligems/ig-types";
import { capitalizeFirstLetter } from "@intelligems/ig-utils";
import { Search } from "@mui/icons-material";
import { Grid, InputAdornment, MenuItem } from "@mui/material";

import {
  resetExperienceListFilters,
  selectedExperienceListFilters,
  setListFilter,
} from "../../../../../store/slices/appSettings";

export const ExperienceListHeader = () => {
  const dispatch = useDispatch();
  const tableFilters = useSelector(selectedExperienceListFilters);
  const onClear = () => {
    dispatch(resetExperienceListFilters());
  };

  const handleSelectInputChange = (
    event: any,
    filter: "status" | "testTypes"
  ) => {
    const {
      target: { value },
    } = event;

    const parsedValue = typeof value === "string" ? value.split(",") : value;
    const filteredValue = parsedValue.filter((val) => val !== "ig-empty");
    dispatch(
      setListFilter({
        type: "experienceListFilters",
        key: filter,
        value: filteredValue,
      })
    );
  };

  return (
    <Grid
      container
      item
      direction={"row"}
      columnSpacing={0.5}
      justifyContent={"space-between"}
    >
      <Grid item xs={7}>
        <IgTextField
          fullWidth={true}
          sx={{
            backgroundColor: "white",
          }}
          placeholder={"Enter Test Name or ID"}
          value={tableFilters?.search || ""}
          onChange={(e) => {
            dispatch(
              setListFilter({
                type: "experienceListFilters",
                key: "search",
                value: e.target.value,
              })
            );
          }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <Search sx={{ color: "#909090" }} />
              </InputAdornment>
            ),
          }}
        />
      </Grid>
      <Grid item xs={2}>
        <IgSelect
          onChange={(e) => {
            handleSelectInputChange(e, "status");
          }}
          fullWidth={true}
          multiple={true}
          value={
            tableFilters?.status?.length === 0 || !tableFilters
              ? ["ig-empty"]
              : tableFilters?.status
          }
          renderValue={(e: any) =>
            e[0] === "ig-empty" ? "Status" : e.join(", ")
          }
          placeholder={"Status"}
        >
          {ExperienceStatusList.map((status) => (
            <MenuItem
              value={status}
              sx={{
                fontWeight:
                  tableFilters?.status.indexOf(status) === -1 ? 400 : 500,
              }}
              key={status}
            >
              <IgCheckbox
                size={"small"}
                checked={tableFilters?.status.indexOf(status) > -1}
              />
              {capitalizeFirstLetter(status)}
            </MenuItem>
          ))}
        </IgSelect>
      </Grid>
      <Grid item xs={2}>
        <IgSelect
          fullWidth={true}
          multiple={true}
          onChange={(e) => {
            handleSelectInputChange(e, "testTypes");
          }}
          renderValue={(e: any) =>
            e[0] === "ig-empty"
              ? "Test Type"
              : e.map((type) => capitalizeFirstLetter(type)).join(", ")
          }
          placeholder={"Test Type"}
          value={
            tableFilters?.testTypes.length === 0
              ? ["ig-empty"]
              : tableFilters?.testTypes
          }
        >
          {ExperienceTestTypeList.map((testType) => (
            <MenuItem
              value={testType}
              sx={{
                fontWeight:
                  tableFilters?.testTypes.indexOf(testType) === -1 ? 400 : 500,
              }}
              key={testType}
            >
              <IgCheckbox
                size={"small"}
                checked={tableFilters?.testTypes.indexOf(testType) > -1}
              />
              {capitalizeFirstLetter(testType)}
            </MenuItem>
          ))}
        </IgSelect>
      </Grid>
      <Grid sx={{ marginRight: "-20px" }} item xs={1}>
        <IgButton onClick={onClear}>CLEAR</IgButton>
      </Grid>
    </Grid>
  );
};
